import script from "./Collaboration.vue?vue&type=script&setup=true&lang=js"
export * from "./Collaboration.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__